import { IRestfulConfigMap } from "@core/data-access/restful";
import { envConfig } from "@env/env-config";

let IdempotentKeyRestServiceConfig: IRestfulConfigMap = {
    idempotentKeyRestService: {
        appPath: envConfig.appPath("base"),
        isAuth: true,
        actions: {
            get: {
                method: "get",
                path: "api/idempotentOperators",
            }
        }
    }
}


export { IdempotentKeyRestServiceConfig };